import React, {useEffect,useRef} from 'react';
import {NavLink} from 'react-router-dom';
import {url} from '../resapi'
import SlideRecommend from '../slideRecommend';
// import Lottie from 'react-lottie';
import lottie from 'lottie-web';
import Plyr from 'react-plyr';
import '../../asset/css/video.css';
const Page =(props)=>{
  const full = useRef(null)
  function handelCursor(value){
    if(value){
      document.querySelector(".cursor--outer").style.display="none"
      document.querySelector("body").style.cursor="default"
    }
    else {
      document.querySelector(".cursor--outer").style.display="block"
      document.querySelector("body").style.cursor="none"
    }
  }
  useEffect(() => {
    for(let i of document.querySelectorAll(".singlepost .text p")){
      for(let y of i.children){
        if(y.tagName==="IMG"){
          if(y.getAttribute("width")==="100%") {
            i.style.padding=0
            y.style.height= "auto"
          }
        }
      }
    }
    
  }, [])
  useEffect(() => {
    // full.current.enterFullscreen(()=>console.log("message"))
    for(let i of document.querySelectorAll(".singlepost .text span.lottie strong")){
      const pathJSON = i.innerHTML.split('id="')[1].split(".json")[0]
      const width = i.innerHTML.split('width="')[1].split('"')[0]
      const height = i.innerHTML.split('height="')[1].split('"')[0]
      const target = i.parentElement
      target.style.width = width;
      target.style.height = height;
      lottie.loadAnimation({
        container: i.parentElement, // the dom element that will contain the animation
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: url+"/"+pathJSON+".json" // the path to the animation json
      });
      i.parentElement.innerHTML=""
    }
  },[])
  return (
  <React.Fragment>
     <div className="container">
      
     {parseInt(props.index)===0?
          <div className="projectsection sectionheader" style={{color:"#000"}}>
            <NavLink to="/" className="clickable" style={{color:"inherit"}}>home</NavLink>
            <NavLink to={`/${props.route.pagename}`} className="clickable" style={{color:"inherit"}}>{props.route.pagename}</NavLink>
            <NavLink to={`/${props.route.pagename}/${props.route.params}`} style={{color:"inherit"}} className="clickable">{props.route.name}</NavLink>
        </div>:""}

       <div className="ltr">
       <div className="row">
           <div className="singlepost" style={{width:"100%"}}>
             <div className="text clearfix">
              {/* {editorState} */}
              <div dangerouslySetInnerHTML={{__html: props.data.html}} />
              {/* <img src="http://masoudrostami.com/wp-content/uploads/2018/07/Jam-City-design02.jpg" alt="jhkh"/> */}
              {props.data.attach?
              <div className="video"
              onMouseEnter={()=>handelCursor(true)}
              onMouseLeave={()=>handelCursor(false)}
              >
               <Plyr
                  type="video"
                  volume={0}
                  ref={full}
                  fullscreen={ {enabled: false, fallback: true, iosNative: true} }
                  controls={[ 'play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'pip', 'airplay', 'fullscreen' ]}
                  ratio={false}
                  url={url+"/"+props.data.attach}
                />
              </div>
              :""}
             </div>
              
             {props.recommend && props.recommend.length>0?
             <>
             <div className="social">
                <span>SHARE IT :</span>
                <a href={"https://www.facebook.com/sharer/sharer.php?u=" + window.location.href} target="_blank" rel="noopener noreferrer" className="clickable"><i className="icon icon-facebook"></i></a>
                <a href={"https://www.linkedin.com/shareArticle?mini=true&url="+window.location.href} target="_blank" rel="noopener noreferrer" className="clickable"><i className="icon icon-linkedin"></i></a>
                <a href={"https://twitter.com/home?status=" + window.location.href} target="_blank" rel="noopener noreferrer" className="clickable"><i className="icon icon-twitter"></i></a>
                <a href={"https://telegram.me/share/url?url=" + window.location.href+"&text="} target="_blank" rel="noopener noreferrer" className="clickable"><i className="icon icon-telegram"></i></a>
              </div>
             
             <SlideRecommend title="You may also like" data={props.recommend} route={props.route}/>
             </>
             :""
             }
           </div>
       </div>
       </div>
     </div>
   </React.Fragment>
  );
}
export default Page
